(function () {
  'use strict';

  var settings = window.themeSettings || {};

  function trapFocus(container) {
    var focusable = container.querySelectorAll(
      'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    container.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  function lockBodyScroll(lock) {
    document.body.style.overflow = lock ? 'hidden' : '';
  }

  function openDrawer(drawer, overlay) {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) {
      overlay.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
    }
    lockBodyScroll(true);
    trapFocus(drawer);
  }

  function closeDrawer(drawer, overlay) {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) {
      overlay.classList.remove('is-visible');
      setTimeout(function () { overlay.hidden = true; }, 300);
    }
    lockBodyScroll(false);
  }

  function initDrawers() {
    var menuToggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    var menuOverlay = document.querySelector('[data-menu-overlay]');
    var menuClose = document.querySelector('[data-menu-close]');

    if (menu && menuOverlay) {
      if (menuOverlay.parentElement !== document.body) {
        document.body.appendChild(menuOverlay);
      }
      if (menu.parentElement !== document.body) {
        document.body.appendChild(menu);
      }
    }

    if (menuToggle && menu && menuToggle.dataset.drawerBound !== 'true') {
      menuToggle.dataset.drawerBound = 'true';
      menuToggle.addEventListener('click', function () {
        var isOpen = menu.classList.contains('is-open');
        if (isOpen) {
          closeDrawer(menu, menuOverlay);
          menuToggle.setAttribute('aria-expanded', 'false');
        } else {
          openDrawer(menu, menuOverlay);
          menuToggle.setAttribute('aria-expanded', 'true');
        }
      });
    }

    if (menuClose && menu && menuClose.dataset.drawerBound !== 'true') {
      menuClose.dataset.drawerBound = 'true';
      menuClose.addEventListener('click', function () {
        closeDrawer(menu, menuOverlay);
        if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
      });
    }

    if (menuOverlay && menu && menuOverlay.dataset.drawerBound !== 'true') {
      menuOverlay.dataset.drawerBound = 'true';
      menuOverlay.addEventListener('click', function () {
        closeDrawer(menu, menuOverlay);
        if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
      });
    }

    var cartToggle = document.querySelector('[data-cart-toggle]');
    var cartDrawer = document.querySelector('[data-cart-drawer]');
    var cartOverlay = document.querySelector('[data-drawer-overlay]');
    var cartClose = document.querySelector('[data-cart-close]');

    if (cartToggle && cartDrawer && settings.cartType === 'drawer') {
      cartToggle.addEventListener('click', function () {
        openDrawer(cartDrawer, cartOverlay);
      });
    }

    if (cartClose && cartDrawer) {
      cartClose.addEventListener('click', function () {
        closeDrawer(cartDrawer, cartOverlay);
      });
    }

    if (cartOverlay && cartDrawer) {
      cartOverlay.addEventListener('click', function () {
        closeDrawer(cartDrawer, cartOverlay);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (menu && menu.classList.contains('is-open')) {
          closeDrawer(menu, menuOverlay);
          if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
        }
        if (cartDrawer && cartDrawer.classList.contains('is-open')) {
          closeDrawer(cartDrawer, cartOverlay);
        }
        var searchModal = document.querySelector('[data-search-modal]');
        if (searchModal && searchModal.classList.contains('is-open')) {
          closeSearchModal();
        }
      }
    });
  }

  function openSearchModal() {
    var modal = document.querySelector('[data-search-modal]');
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    lockBodyScroll(true);
    var input = modal.querySelector('.search-modal__input');
    if (input) input.focus();
  }

  function closeSearchModal() {
    var modal = document.querySelector('[data-search-modal]');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    lockBodyScroll(false);
  }

  function initSearch() {
    var toggle = document.querySelector('[data-search-toggle]');
    var modal = document.querySelector('[data-search-modal]');
    if (!toggle || !modal) return;

    toggle.addEventListener('click', openSearchModal);
    modal.querySelectorAll('[data-search-close]').forEach(function (btn) {
      btn.addEventListener('click', closeSearchModal);
    });

    var popularData = document.querySelector('[data-popular-searches]');
    var tagContainer = modal.querySelector('[data-popular-search-tags]') || document.querySelector('[data-popular-search-tags]');
    if (popularData && tagContainer) {
      try {
        var terms = JSON.parse(popularData.textContent);
        if (terms.length) {
          tagContainer.innerHTML = terms.map(function (term) {
            return '<a href="' + (settings.routes && settings.routes.searchUrl ? settings.routes.searchUrl : '/search') + '?q=' + encodeURIComponent(term) + '" class="tag">' + term + '</a>';
          }).join('');
        }
      } catch (e) { /* ignore */ }
    }
  }

  function updateCartCount(count) {
    var el = document.querySelector('[data-cart-count]');
    if (!el) return;
    el.textContent = count;
    el.classList.toggle('hidden', count === 0);
  }

  function formatMoney(cents, stripDecimals) {
    var amount = cents / 100;
    var value = stripDecimals ? Math.round(amount) : amount;
    var formatted = value.toLocaleString(undefined, {
      minimumFractionDigits: stripDecimals ? 0 : 2,
      maximumFractionDigits: stripDecimals ? 0 : 2
    });
    if (window.theme && window.theme.settings && window.theme.settings.moneyFormat) {
      return window.theme.settings.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, formatted).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(amount));
    }
    return 'Rs.' + formatted;
  }

  function renderCartDrawer(cart) {
    var body = document.querySelector('[data-cart-drawer-body]');
    var footer = document.querySelector('[data-cart-footer]');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty" data-cart-empty><p>' + (settings.strings && settings.strings.cartEmpty ? settings.strings.cartEmpty : 'Your cart is empty') + '</p><a href="/collections/all" class="btn btn--primary">Continue shopping</a></div>';
      if (footer) footer.classList.add('hidden');
      return;
    }

    if (footer) footer.classList.remove('hidden');

    var html = '<ul class="cart-drawer__items" data-cart-items>';
    cart.items.forEach(function (item, index) {
      html += '<li class="cart-drawer__item" data-cart-item data-line="' + (index + 1) + '">';
      html += '<a href="' + item.url + '" class="cart-drawer__item-image">';
      if (item.image) html += '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy" width="80">';
      html += '</a><div class="cart-drawer__item-details">';
      html += '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        html += '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>';
      }
      html += '<div class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>';
      html += '<div class="quantity-selector">';
      html += '<button type="button" class="quantity-selector__btn" data-quantity-minus aria-label="Decrease">−</button>';
      html += '<input type="number" class="quantity-selector__input" value="' + item.quantity + '" min="0" data-quantity-input>';
      html += '<button type="button" class="quantity-selector__btn" data-quantity-plus aria-label="Increase">+</button>';
      html += '</div>';
      html += '<button type="button" class="cart-drawer__remove" data-remove-item>Remove</button>';
      html += '</div></li>';
    });
    html += '</ul>';
    body.innerHTML = html;

    var subtotal = document.querySelector('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    bindCartItemEvents();
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        renderCartDrawer(cart);
      })
      .catch(function () {});
  }

  function changeCartLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        renderCartDrawer(cart);
      });
  }

  function bindCartItemEvents() {
    document.querySelectorAll('[data-cart-item]').forEach(function (item) {
      var line = parseInt(item.dataset.line, 10);
      var input = item.querySelector('[data-quantity-input]');
      var minus = item.querySelector('[data-quantity-minus]');
      var plus = item.querySelector('[data-quantity-plus]');
      var remove = item.querySelector('[data-remove-item]');

      if (minus) minus.addEventListener('click', function () {
        changeCartLine(line, Math.max(0, parseInt(input.value, 10) - 1));
      });
      if (plus) plus.addEventListener('click', function () {
        changeCartLine(line, parseInt(input.value, 10) + 1);
      });
      if (remove) remove.addEventListener('click', function () {
        changeCartLine(line, 0);
      });
    });
  }

  function initCartForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.product-card__form, .product-single__form, [data-product-form], [data-product-form-main]');
      if (!form || settings.cartType !== 'drawer') return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"][name="add"]');
      if (submitBtn) submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw data;
            return data;
          });
        })
        .then(function () {
          refreshCartDrawer();
          var cartDrawer = document.querySelector('[data-cart-drawer]');
          var cartOverlay = document.querySelector('[data-drawer-overlay]');
          if (cartDrawer) openDrawer(cartDrawer, cartOverlay);
        })
        .catch(function (err) {
          var message = err && err.description ? err.description : 'Could not add to cart. Please try again.';
          alert(message);
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    }, true);

    bindCartItemEvents();
  }

  function initAccordions() {
    if (document.documentElement.dataset.accordionsDelegated === 'true') return;
    document.documentElement.dataset.accordionsDelegated = 'true';

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-accordion-trigger]');
      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();

      var item = trigger.closest('[data-accordion-item]');
      if (!item) return;

      var isOpen = item.classList.contains('is-open');
      var group = item.closest('[data-accordion]');
      if (group && group.dataset.accordionSingle !== 'false') {
        group.querySelectorAll('[data-accordion-item]').forEach(function (i) {
          i.classList.remove('is-open');
          var t = i.querySelector('[data-accordion-trigger]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }

      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      } else {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function measureHeaderOffsetBottom() {
    var bottom = 0;
    var selectors = [
      '.shopify-section-group-header-group .top-ticker.announcement-bar',
      '.shopify-section-group-header-group .announcement-bar',
      '[data-site-header]'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        var rect = node.getBoundingClientRect();
        var style = window.getComputedStyle(node);
        if (rect.height <= 0) return;
        if (style.display === 'none' || style.visibility === 'hidden') return;
        if (rect.bottom > bottom) bottom = rect.bottom;
      });
    });

    if (bottom <= 0) {
      var rootStyles = getComputedStyle(document.documentElement);
      var headerHeight = parseFloat(rootStyles.getPropertyValue('--header-height')) || 64;
      var announcementHeight = parseFloat(rootStyles.getPropertyValue('--announcement-height')) || 36;
      bottom = headerHeight + announcementHeight;
    }

    bottom = Math.ceil(bottom);
    document.documentElement.style.setProperty('--header-offset-bottom', bottom + 'px');
    return bottom;
  }

  window.theme = window.theme || {};
  window.theme.measureHeaderOffsetBottom = measureHeaderOffsetBottom;

  function initStickyHeader() {
    var header = document.querySelector('[data-site-header]');
    if (!header || header.dataset.stickyBound === 'true') return;

    header.dataset.stickyBound = 'true';

    var styleThreshold = parseInt(header.dataset.scrollThreshold, 10);
    if (isNaN(styleThreshold)) styleThreshold = 20;
    var ticking = false;
    var headerGroup = document.querySelector('.shopify-section-group-header-group');

    function getScrollY() {
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }

    function stripLegacyStuckClasses() {
      header.classList.remove('site-header--stuck', 'site-header--opening');
    }

    function updateScrollState() {
      ticking = false;
      var scrollY = getScrollY();
      var styleScrolled = scrollY > styleThreshold;

      stripLegacyStuckClasses();
      header.classList.toggle('is-scrolled', styleScrolled);
      document.documentElement.classList.toggle('header-is-scrolled', styleScrolled);
      measureHeaderOffsetBottom();
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateScrollState);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      var headerResizeObserver = new ResizeObserver(onScroll);
      headerResizeObserver.observe(header);
      if (headerGroup) headerResizeObserver.observe(headerGroup);
    }

    updateScrollState();
  }

  document.addEventListener('DOMContentLoaded', bootZeroHeader);
  document.addEventListener('shopify:section:load', function () {
    bootZeroHeader();
  });

  if (document.readyState !== 'loading') {
    bootZeroHeader();
  }

  function bootZeroHeader() {
    if (document.querySelector('[data-site-header]') || document.querySelector('.shopify-section-group-header-group')) {
      measureHeaderOffsetBottom();
    }
    initAccordions();
    if (!document.querySelector('[data-site-header]')) return;
    initDrawers();
    initSearch();
    initCartForms();
    initStickyHeader();
  }
})();
